/**
 * Branon design tokens — Direction F, as plain JS/TS constants for shared
 * components that use inline styles (see AuthDecor.tsx's own note on why:
 * none of the consuming apps' Tailwind content globs scan `../shared/**`,
 * so Tailwind classes written here would silently produce no CSS).
 *
 * Keep in sync by hand with design-tokens.css / tailwind-preset.js.
 * See /redesignplan.md for the design decision history.
 */

export const INK = '#171512'
export const PAPER = '#F7F6F4'
export const GRAY_50 = '#FAF9F7'
export const GRAY_100 = '#F1EFEC'
export const GRAY_200 = '#E4E1DC'
export const GRAY_400 = '#8A8580'
export const GRAY_600 = '#6B6660'
export const GRAY_700 = '#4A4640'

export const NIGHT = '#151A2E'
export const MARIGOLD = '#FFE14D'
export const CORAL = '#FF6B4A'

export const SUCCESS = '#0F8A5F'
export const SUCCESS_SOFT = '#DFF3EA'
export const WARNING = '#B7791F'
export const WARNING_SOFT = '#F1E8D2'
export const CRITICAL = '#C0392B'
export const CRITICAL_SOFT = '#FBE4E1'

export const FONT_QUICKSAND = "'Quicksand', sans-serif"
export const FONT_INTER = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

export const RADIUS_CARD = 16
export const RADIUS_BTN = 12

/** The hard "sticker" drop-shadow — no blur, no transparency. This is the
 * one shadow Direction F uses; there is no glassmorphism anywhere in it. */
export const SHADOW_STICKER = `0 4px 0 ${INK}`
